const LogoutConfirmation = ({ t, handleLogout }) => {
  return (
    <>
      {/* <!-- Modal --> */}
      <div
        className="modal fade"
        id="logout-modal"
        tabIndex="-1"
        aria-labelledby="logout-modal-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content  my-modal">
            <div className="modal-body">
              <i className="fas fa-power-off text-danger"></i> {t("logoutConfirmation")}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
                onClick={handleLogout}
              >
                {t("ok")}
              </button>
              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
              >
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoutConfirmation;
